module.exports = global["React"] = require("-!./react.js");


//////////////////
// WEBPACK FOOTER
// ./~/react/react.js-exposed
// module id = 258
// module chunks = 0